import { PiDownloadSimpleBold } from "react-icons/pi";
import PrintButton from "@/app/shared/print-button";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import { Button } from "rizzui";
import routes from "@/routers/routes";
import { fetchBillings, fetchOrderById } from "@/server/api-services";
import { Billing, Order, OrderStatus } from "@/types";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import BillingDetails from "@/app/shared/orders/billing-details";

export const metadata = {
    ...metaObject("Billing"),
};

const pageHeader = {
    title: "Billing Details",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Home",
        },
        {
            href: routes.billing.home,
            name: "Billing",
        },
        {
            name: "Details",
        },
    ],
};

export default function BillingDetailsPage() {
    const { id } = useParams();
    const [Billings, setBillings] = useState([] as Billing[]);
    const [order, setOrder] = useState({} as Order);

    useEffect(() => {
        if (id !== undefined) {
            getBillings();
            getOrder();
        }
    }, [id]);

    async function getBillings() {
        const response = await fetchBillings(id as string);
        if (response.statusCode !== 200) {
            toast.error("Failed to fetch Billings");
            return;
        }

        var data = response.data as Billing[];

        setBillings(data);
    }

    const getOrder = async () => {
        const response = await fetchOrderById(id as string);

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order;

        data = {
            ...data,
            status: OrderStatus[data.status as keyof typeof OrderStatus],
        };

        setOrder(data);
    };
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <div className="mt-4 flex items-center gap-3 @lg:mt-0">
                    <PrintButton />
                    {/* <Button className="w-full @lg:w-auto">
                        <PiDownloadSimpleBold className="me-1.5 h-[17px] w-[17px]" />
                        Download
                    </Button> */}
                </div>
            </PageHeader>

            <BillingDetails Billings={Billings} order={order} />
        </>
    );
}
